import React from 'react';
import styles from './requirementsText.module.scss';

const RequirementsText = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className={styles.container}>
            <h3>
              Pareiškėjas turi tenkinti VISAS šias sąlygas norint gauti dalinį
              nuomos mokesčio kompensavimą
            </h3>
            <p>
              1. Pareiškėjas įmonė – ekonominę veiklą vykdantis juridinis asmuo
              (išskyrus valstybės ir savivaldybių įmones ir įmones, kuriose 25
              procentus ir daugiau įmonės akcijų, pajų ar kitokių dalyvavimą
              įmonės kapitale žyminčių kapitalo dalių arba 25 procentus ir
              daugiau įmonės dalyvių balsų tiesiogiai ar netiesiogiai (pagal
              balsavimo sutartį, balsavimo teisės perleidimo sutartį, įgaliojimą
              ir pan.) atskirai arba kartu turi valstybė ir (ar) savivaldybė),
              kurio metinės pajamos 2019 m. neviršijo 50 000 000 Eur
              (penkiasdešimt milijonų eurų) arba turto balansinė vertė 2019 m.
              gruodžio 31 d. neviršijo 43 000 000 Eur (keturiasdešimt trijų
              milijonų eurų).
            </p>
            <p>
              2. Pareiškėjas verslininkas – kaip ši sąvoka apibrėžta Lietuvos
              Respublikos smulkiojo ir vidutinio verslo plėtros įstatyme.
            </p>
            <p>
              3. Pareiškėjo vykdoma pagrindinė veikla atitinka veiklas, kurios
              karantino laikotarpiu buvo arba yra uždraustos Lietuvos
              Respublikos Vyriausybės 2020 m. kovo 14 d. nutarimu Nr. 207 „Dėl
              karantino Lietuvos Respublikos teritorijoje paskelbimo“ (toliau -
              Nutarimas) ir kurių draudimo laikotarpiu jis nevykdė. Aplinkybė,
              kad tam tikra veikla karantino laikotarpio pradžioje buvo
              uždrausta Nutarimu, tačiau pakeitus Nutarimą karantino laikotarpiu
              tapo leidžiama, neturi įtakos šiame Apraše nustatytam nuomos
              mokesčio kompensacijos skyrimui ir mokėjimui, jeigu pareiškėjas
              tokios veiklos jos draudimo laikotarpiu nevykdė. Taip pat Apraše
              nustatytam nuomos mokesčio kompensacijos skyrimui ir mokėjimui
              įtakos neturi aplinkybė, kad pareiškėjas nevykdydamas karantino
              laikotarpiu uždraustos savo pagrindinės veiklos, vykdė
              nepagrindinę Nutarimu neuždraustą veiklą.
            </p>
            <p>
              4. Pareiškėjo vykdoma pagrindinė veikla nėra elektroninė prekyba,
              ginklų ir šaudmenų specializuota mažmeninė prekyba, azartinių
              žaidimų ir lažybų ar kitų azartinių lošimų organizavimo veikla,
              finansų įstaigų vykdoma veikla.
            </p>
            <p>
              5. Pareiškėjas 2019 m. gruodžio 31 d. nebuvo sunkumų patirianti
              įmonė, kaip tai apibrėžta 2014 m. birželio 17 d. Komisijos
              reglamento (ES) Nr. 651/2014, kuriuo tam tikrų kategorijų pagalba
              skelbiama suderinama su vidaus rinka taikant Sutarties 107 ir 108
              straipsnius, 2 straipsnio 18 punkte.
            </p>
            <p>
              6. Pareiškėjas paraiškos pateikimo metu nėra įgijęs
              bankrutuojančios, restruktūrizuojamos, likviduojamos įmonės
              statuso.
            </p>
            <p>
              7. Pareiškėjas yra įregistruotas Juridinių asmenų registre (kai
              pareiškėjas yra įmonė) arba pradėjo vykdyti veiklą (kai
              pareiškėjas yra verslininkas) ne vėliau kaip 2020 m. kovo 16
              dieną.
            </p>
            <p>
              8. Pareiškėjas ir nuomotojas negali priklausyti tai pačiai įmonių
              grupei ir (ar) pareiškėjas negali nuomotis patalpų iš nuomotojo,
              kai nuomotojas yra fizinis asmuo, turintis daugumą dalyvių balsų
              įmonėje, teikiančioje paraišką.
            </p>
            <p>
              9. Pareiškėjas (išskyrus, kai pareiškėjas yra verslininkas)
              paraiškos pateikimo metu turi būti pateikęs 2019 m. metinių
              finansinių ataskaitų rinkinį valstybės įmonei Registrų centrui.
            </p>
            <p>
              10. Jeigu pareiškėjas priklauso įmonių grupei, turi įkelti į
              paraiškos teikimo aplinką pasirašytas konsoliduotąją pelno
              (nuostolio) ataskaitą ir konsoliduotą balansą: už 2019 m.
              (laikotarpiui nuo 2019-01-01 iki 2019-12-31), jeigu pareiškėjas
              yra MVĮ (labai maža, maža arba vidutinė įmonė kaip nustatyta LR
              Smulkiojo ir vidutinio verslo plėtros įstatyme); už 2019 m. ir
              2018 m. (laikotarpiui nuo 2019-01-01 iki 2019-12-31 ir
              laikotarpiui nuo 2018-01-01 iki 2018-12-31), jeigu pareiškėjas
              nėra MVĮ.
            </p>
            <p>
              11. Pareiškėjas neturi būti gavęs neteisėtos pagalbos, kuri
              Europos Komisijos sprendimu (dėl individualios pagalbos arba
              pagalbos schemos) buvo pripažinta neteisėta ir nesuderinama su
              vidaus rinka arba yra grąžinęs visą jos sumą, įskaitant palūkanas,
              teisės aktuose nustatyta tvarka.
            </p>
            <p>
              12. Pareiškėjas su nuomotoju yra sudaręs patalpų nuomos sutartį
              savo ekonominei veiklai vykdyti.
            </p>
            <p>
              13. Patalpų nuomos sutartis pasirašyta ne vėliau kaip 2020 m. kovo
              15 d.
            </p>
            <p>
              14. Patalpų numos sutartis paraiškos pateikimo metu yra galiojanti
              ir registruota valstybės įmonėje Registrų centre. ir registruota
              valstybės įmonėje Registrų centre.
            </p>
            <p>15. Patalpų nuomotojas nėra valstybės turto valdytojas.</p>
            <p>
              16. Patalpų nuomotojas po karantino paskelbimo datos yra sumažinęs
              nuomos mokestį pareiškėjui ne mažiau kaip 30 proc. (kompensavimo
              laikotarpiu pareiškėjo ir nuomotojo sutartas nuomos mokestis
              lyginamas su 2020 m. vasario mėn. galiojusio nuomos mokesčio
              dydžiu. Jeigu pareiškėjas nuo savo veiklos pradžios pirmąjį nuomos
              mokestį sumokėjo už 2020 m. kovo mėn., kompensavimo laikotarpio
              nuomos mokestis lyginamas su 2020 m. kovo mėn. pareiškėjui taikytu
              nuomos mokesčiu. Jeigu pareiškėjas nuo savo veiklos pradžios
              pirmąjį nuomos mokestį sumokėjo už 2020 m. balandžio mėn. ar
              vėlesnius mėnesius, kompensavimo laikotarpio nuomos mokestis
              lyginamas su nuomos sutartyje numatytu mėnesio nuomos mokesčiu.
              Jei pareiškėjas nuo savo veiklos pradžios pirmąjį nuomos mokestį
              sumokėjo už 2020 m. kovo mėn. ir kovo mėn. jam jau buvo pritaikytą
              nuolaida, kompensavimo laikotarpio nuomos mokestis lyginamas su
              nuomos sutartyje nurodytu nuomos mokesčiu).
            </p>
            <p>
              17. Nuomotojo išrašytos PVM sąskaitos–faktūros, pagal kurias bus
              skaičiuojama kompensacija, yra pateiktos į VMI prie LR FM
              „Išmaniąją mokesčių administravimo sistemą (i.MAS)."
            </p>
            <p>
              18. Pareiškėjas nėra gavęs nuomos mokesčio kompensavimo už
              kompensavimo laikotarpiu patirtas nuomos mokesčio įšlaidas iš kitų
              Lietuvos Respublikos valstybės biudžeto ir (arba) savivaldybių
              biudžetų, kitų piniginių išteklių, kuriais disponuoja valstybė ir
              (ar) savivaldybė, Europos Sąjungos struktūrinių fondų, kitų
              Europos Sąjungos finansinės paramos priemonių ar kitos
              tarptautinės paramos lėšų.
            </p>
            <p>
              19. Pareiškėjui teikiamo finansavimo (subsidijų, dotacijų,
              grąžintinų avansų, mokesčių lengvatų forma) pagal Komunikatą
              (Komunikatas – Europos Komisijos 2020 m. kovo 19 d. komunikatas
              Laikinoji valstybės pagalbos priemonių, skirtų ekonomikai remti
              reaguojant į dabartinį COVID-19 protrūkį, sistema su paskutiniais
              pakeitimais) suma negali viršyti 800 000 eurų, o jei pareiškėjas
              vykdo veiklą žuvininkystės ir akvakultūros sektoriuje - 120 000
              eurų, o jei pareiškėjas vykdo veiklą pirminės žemės ūkio produktų
              gamybos srityje - 100 000 eurų per Komunikato taikymo laikotarpį.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RequirementsText;
